namespace Areas.Drawing.Upload {

    "use strict";

    let runQuery = false;
    let projectId = 0;

    export function selectProject() {
        const projectDialog = new Areas.Dialog.ProjectDialog(dialogClosing);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        projectId = data.projectId;

        updateBuildingProjectLookup();
        updateClassificationForm(data.title);        
        Areas.enableButton("ClearProjectSelection");
    } 


    export function gotoClassifyDrawings() {
        location.href = "/Drawing/Classify/Index";
    }

    export function associateUploadWithBuildingProject(selectedBuildingProjectId: number) {

        const uploader = $("#fileUploaderControl").dxFileUploader("instance");
        let url: any = uploader.option("uploadUrl");

        if (selectedBuildingProjectId > 0) {
            url = updateQueryStringParameter(url, "buildingProjectId", selectedBuildingProjectId);
            uploader.option("disabled", false);
        } else {
            url = removeQueryStringParameter(url, "buildingProjectId");
            uploader.option("disabled", true);
        }

        uploader.option("uploadUrl", url);
    }

    function updateBuildingProjectLookup() {

        runQuery = true;

        const lookupForm = $("#ClassificationForm").dxForm("instance");

        const buildingLookup = lookupForm.getEditor("BuildingProjectId") as DevExpress.ui.dxLookup;

        buildingLookup.option("disabled", false);
        buildingLookup.getDataSource().reload();
        buildingLookup.reset();
    }

    function updateClassificationForm(title: string) {
        const classificationForm = $("#ClassificationForm").dxForm("instance");
        var data = classificationForm.option("formData") as any;

        data.Title = title;
        classificationForm.option("formData", data);
    }

    export function clearProjectSelection() {
        const lookupForm = $("#ClassificationForm").dxForm("instance");

        Areas.disableButton("ClearProjectSelection");

        const luTitleControl = lookupForm.getEditor("Title") as DevExpress.ui.dxTextBox;
        luTitleControl.option("value", "");

        const buildingLookup = lookupForm.getEditor("BuildingProjectId") as DevExpress.ui.dxLookup;

        buildingLookup.reset();
        runQuery = false;
        buildingLookup.getDataSource().reload();
        buildingLookup.option("disabled", true);
    }

    export function getProjectId() {
        return projectId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function buildingProjectSelected(e: any) {
        if (e.selectedItem !== null) {
            associateUploadWithBuildingProject(e.selectedItem.buildingProjectId);
        } else {
            associateUploadWithBuildingProject(0);
        }
    }

    export function uploadError(e: any) {
        const defaultTimeOut = 4000;

        const responseText = e.request.responseText;

        const toastrOptions = { timeOut: defaultTimeOut, positionClass: "toast-bottom-full-width", showMethod: "show" };
        toastr.error(responseText, "Error", toastrOptions);
    }

    export function buildingLookupTemplate(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div style="width:400px;"><span class="collookupspan" style="width:50px;">${itemData.caan}</span>${itemData.name}</div>`);
    } 
    
    export function displayBuildingExpression(data: any): string {
        if (data) {
            return data.caan + " - " + data.name; 
        }

        return "Select ...";
    }    
}